import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const BaseTabWrapper = styled.button.attrs({
  type: "button"
})`
  background-color: ${props => (props.active ? colors.glass : "#ffffff")};
  border: 1px solid ${colors.foxGrey};
  box-sizing: border-box;
  color: ${colors.whaleGrey};
  display: inline-block;
  font: 14px/38px "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  height: 40px;
  line-height: 38px;
  margin: 0;
  text-align: center;
  flex: 1 1 100%;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  ${props =>
    props.isDisabled &&
    `
    background: ${props.active ? colors.rabbitGrey : "#ffffff"};
    pointer-events: none;
  `}

  &:not(:last-child) {
    margin-right: -1px;
  }

  &:hover {
    background-color: ${props =>
      props.active ? colors.glass : colors.frostedGlass};
    cursor: pointer;
  }

  &:disabled {
    background-color: #ffffff;
    border-color: ${colors.foxGrey};
    color: ${colors.koalaGrey};
    cursor: default;
    pointer-events: none;
  }

  * {
    box-sizing: inherit;
  }
`;

const TextHoverTab = styled(BaseTabWrapper)`
  background-color: ${props =>
    props.active ? colors.frostedGlass : "#ffffff"};
  color: ${props => (props.active ? colors.classicBlue : colors.koalaGrey)};

  &:hover {
    background-color: ${props =>
      props.active ? colors.frostedGlass : "#ffffff"};
    color: ${colors.classicBlue};
  }
`;

const TabEnum = {
  textHover: TextHoverTab
};

BaseTabWrapper.displayName = "BaseTabWrapper";
TextHoverTab.displayName = "TextHoverTab";

export { TabEnum, BaseTabWrapper };
